import { queryOptions } from "@tanstack/react-query";

import { fetchCdnJson } from "@/api/fetchCdnJson";
import { startEarly, takeEarly } from "@/utils/earlyRequest";

const fetchPromoConfig = (promoId: string) =>
  fetchCdnJson(`${import.meta.env.VITE_WIDGET_CDN_BASE_URL}/promo/${promoId}/config.json`);

export const startPromoConfig = (promoId: string) =>
  startEarly(`promoConfig:${promoId}`, () => fetchPromoConfig(promoId));

export const promoConfigQuery = (promoId: string) =>
  queryOptions({
    queryKey: ["promoConfig", promoId],
    queryFn: () => takeEarly(`promoConfig:${promoId}`, () => fetchPromoConfig(promoId)),
  });
